// extracted by mini-css-extract-plugin
export default {"loaderContainer":"TouristsFormLoader-module__loaderContainer__p3Vn8","loader":"TouristsFormLoader-module__loader__bC9BI","text":"TouristsFormLoader-module__text__IAytE"};